<template>
    <div id="app">
        <div v-if="error" id="error">
            <section class="hero is-danger">
                <div class="hero-body">
                    <div class="container">
                        <h1 class="title">
                            {{ $t(`errors.${error}.title`, {NAME: HAS_BVCD ? 'CampNerd CHANGER' : 'CampNerd CHANGER'}) }}
                        </h1>
                        <h2 class="subtitle">
                            {{ $t(`errors.${error}.content`) }}
                        </h2>
                    </div>
                </div>
            </section>
        </div>
        <nprogress-container></nprogress-container>
        <navbar v-if="loggedIn && !error" :campground="campground" :campgrounds="campgrounds" :checks="checks"></navbar>
        <sidebar v-if="loggedIn && !error" :campground="campground" :campgrounds="campgrounds" :checks="checks"></sidebar>
        <div class="main-content" :class="{ 'is-loggedin': loggedIn }" v-if="!error">
            <notifications></notifications>
            <template v-if="$route.matched.length">
                <router-view></router-view>
            </template>
            <template v-else>
                <preloader></preloader>
            </template>
        </div>

        <!-- preloader -->
        <preloader v-if="bootstrapping && loggedIn && !error"></preloader>
    </div>
</template>

<script>
    import Vue from 'vue';
    import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
    import moment from 'moment';

    import { Navbar, Sidebar, Preloader, Notifications } from './views/components';
    import { Api } from './api';
    import { AppModel } from './models';
    import { EventBus, Tracking } from './utils';

    export default {
        name: 'app',

        components: {
            Navbar,
            NprogressContainer,
            Notifications,
            Preloader,
            Sidebar,
        },

        data() {
            return {
                HAS_BVCD: AppModel.hasBvcd,
                error: false,
                bootstrapping: true,
                loggedIn: Api.user.loggedIn(),
                campground: AppModel.activeCampground,
                campgrounds: AppModel.campgrounds,
                checks: AppModel.checks,
            };
        },

        created() {
            EventBus.$on(EventBus.LOGIN_DONE, this.onLoginDone);
            EventBus.$on(EventBus.LOGOUT_DONE, this.onLogoutDone);
            EventBus.$on(EventBus.SWITCH_LANGUAGE_START, this.onSwitchLanguageStart);
            // EventBus.$on(EventBus.WS_MESSAGE_RECEIVED, this.onWebSocketMessageReceived);
            EventBus.$on(EventBus.USER_HAS_NO_NO_CAMPGROUND, this.onUserHasNoCampground);
            EventBus.$on(EventBus.UPDATE_CHECKS, this.onCheckUpdate);
            EventBus.$on(EventBus.BOOTSTRAP_RESET, this.onBootstrapReset);
            EventBus.$on(EventBus.ERROR, this.onMainError);
            EventBus.$emit(EventBus.SWITCH_LANGUAGE_START, {lang: AppModel.lang});

            Tracking.trackInitialPerformance();

            if(this.loggedIn) {
                this.bootstrap();
            }
        },

        methods: {
            onSwitchLanguageStart(data) {
                Vue.config.lang = data.lang;
                moment.locale(data.lang);
                EventBus.$emit(EventBus.SWITCH_LANGUAGE_DONE, {lang: data.lang});
            },

            onLoginDone(data) {
                this.loggedIn = data.success;
                if(data.success) {
                    this.bootstrap();
                }
            },

            onLogoutDone() {
                this.loggedIn = false;
                Api.bootstrapData = null;
            },

            onWebSocketMessageReceived(data) {
                if(data.type === 'booking') {
                    const title = this.$t(`bookings.bookings.notifications.${data.data.event}.title`);
                    let body = this.$t(`bookings.bookings.notifications.${data.data.event}.body`);
                    const mtype = this.$t(`bookings.bookings.notifications.${data.data.event}.type`);

                    Object.keys(data.data).forEach((key) => {
                        body = body.replace(`{${key}}`, data.data[key]);
                    });

                    EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                        title: title,
                        body: body,
                        type: mtype,
                        direction: 'Up',
                        duration: 10000,
                    });

                    EventBus.$emit(EventBus.BOOTSTRAP_RESET);
                }
            },

            onUserHasNoCampground() {
                console.warn('User doesn\'t have any campgrounds. Logging out...');
                Api.user.logout();
                this.$router.push({name: 'login', query: {error: 'no-campground'}});
            },

            bootstrap(force = false) {
                Api.bootstrap(force).then((response) => {
                    if(response.ok) {
                        this.bootstrapping = false;
                        this.campground = AppModel.activeCampground;
                        this.campgrounds = AppModel.campgrounds;
                        this.checks = AppModel.checks;
                        /*
                        setTimeout(() => {
                            MaxCampingSocket.connect(Api.user.getToken());
                        }, 0);
                        */
                    } else {
                        console.error('bootstrap failed');
                    }
                }, () => {
                    console.error('bootstrap failed');
                });
            },

            onMainError(data) {
                this.error = data.code;
            },

            onCheckUpdate() {
                Api.plausibility().then((reponse) => {
                    if(reponse.ok) {
                        this.checks = reponse.body;
                        AppModel.setChecksForCampground(reponse.body);
                        EventBus.$emit(EventBus.UPDATE_CHECKS_DONE, reponse.body);
                    } else {
                        console.log('plausibility update failed');
                    }
                }, () => {
                    console.log('plausibility update failed');
                });
            },

            onBootstrapReset() {
                console.log('bootstrap reset');
                Api.bootstrap(true);
            },
        },
    };
</script>

<style lang="scss">
    @import './app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue